<template>
    <span
        v-if="svgContent && !error && !loading"
        class="svg-icon flex items-center justify-center"
        :aria-label="iconAlt"
        v-html="svgContent" />
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'

const props = defineProps<{
    icon: any;
}>()

const svgContent = ref<string>('')
const iconData = ref<string>(props.icon)
const loading = ref<boolean>(true)
const error = ref<string | null>(null)

const iconAlt = computed(() => {
    return iconData?.value?.alt || iconData?.value?.title || iconData?.value?.fileName || 'SVG Icon'
})

const fetchSvgContent = async () => {
    loading.value = true
    error.value = null
    svgContent.value = ''

    if (iconData.value?.fileExtension?.toLowerCase() !== 'svg') {
        error.value = 'Nur SVG-Dateien werden unterstützt.'
        loading.value = false
        return
    }

    try {
        const response = await fetch(iconData?.value?.url)
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const text = await response.text()
        svgContent.value = text
    } catch (e) {
        if (e instanceof Error) {
            error.value = e.message
            console.log(e)
        } else {
            console.log(e)
        }
    } finally {
        loading.value = false
    }
}

watch(() => props.icon, () => {
    fetchSvgContent()
}, { immediate: true, deep: true })

onMounted(() => {
    fetchSvgContent()
})
</script>
